import React           from 'react';
import PropTypes       from 'prop-types';
import Translations     from '../../../../utils/Translations.js';
import Flux 			from '../../../../flux/Flux';
import Vip30ButtonBadge from '../../../Vip30ButtonBadge.js';

const AlbumButtonVoucher = (props) =>
	<div className={`${props.baseClassName}__button--buy ${props.baseClassName}__button--buy-voucher ${props.additionalClasses}`} onClick={props.onClick}>
        {props.isVip30 && Flux.Guest.isLoggedIn() && Flux.Guest.isVip() && <Vip30ButtonBadge />}
		<div className={` icon -icon-voucher-icon left`} style={{fontSize: "2rem"}} />
		&nbsp;&nbsp;
		<div className={`${props.baseClassName}__text--button`}>{`${Translations.get('Buy')}`}</div>
		<div className={`${props.baseClassName}__text--price`}>{`${props.voucherPrice} Voucher`}</div>
	</div>
;

AlbumButtonVoucher.propTypes = {
	onClick:           PropTypes.func,
	baseClassName: 	   PropTypes.string,
	voucherPrice:  	   PropTypes.number,
    isVip30:       	   PropTypes.bool,
	additionalClasses: PropTypes.string,
};

export default AlbumButtonVoucher;
